import {get, isEmpty, isNil, last} from 'lodash'
import {getUserSettings} from 'selectors/auth'
import {allowedNotInvoicedStatuses, defaultNotInvoicedStatuses} from 'helpers/quotes'

export const getSelectedInvoice = state => state.invoicingContext.selected.invoice
export const getSelectedInvoiceItems = state => state.invoicingContext.selected.items.data.data
export const getLastInvoice = state => last(state.invoicingContext.selected.changeLogInvoice)
export const getLastInvoiceItems = state => last(state.invoicingContext.selected.changeLogInvoiceItems)
export const getDeletedItems = state => state.invoicingContext.selected.deletedItems

export const getInvoices = state => state.invoicingContext.invoices

export const getDeliveredNotInvoiced = state => state.invoicingContext.notInvoiced

export const getDeliveredNotInvoicedStatusFilter = (state) => {
  const {status} = getDeliveredNotInvoiced(state)
  return isNil(status) ? defaultNotInvoicedStatuses : status
}

export const getDeliveredNotInvoicedStatus = (state) => {
  const status = getDeliveredNotInvoicedStatusFilter(state)
  return isEmpty(status) ? allowedNotInvoicedStatuses : status
}
export const getInvoiceSelector = state => state.invoicingContext.selector

export const getPurchaseInvoices = state => state.invoicingContext.purchasing
export const getPurchaseInvoicesTotal = state => state.invoicingContext.purchasing.total
export const getReceivedNotInvoiced = state => state.invoicingContext.receivedNotInvoiced
export const getReceivedNotInvoicedTotal = state => state.invoicingContext.receivedNotInvoiced.total
export const getDeliveredNotInvoicedTotal = state => state.invoicingContext.notInvoiced.total
export const getInvoiceTotal = state => state.invoicingContext.invoices.total

export const getPurchaseInvoiceRequiredFields = state => get(getUserSettings(state), 'purchaseInvoiceRequiredFields.required')

export const getDefaultInvoiceCreateType = state => state.invoicingContext.add.defaultInvoiceCreateType

export const getBatchInvoices = state => state.invoicingContext.invoices.batchInvoices
